import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function InteriorColorSelect() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="choice"
      name="interiorColor"
      label={i18n.t('entity.vehicle.labels.interiorColor')}
      options={catalogueApi?.interiorColorOptions ?? []}
    />
  );
}
